import { collection } from 'typesaurus'
import {
  DisplayBoardType, DisplaySlideType, SlideDetailsType, UserType,
} from '../types'

export const DisplayBoardCollection = collection<DisplayBoardType>('displayBoards')

export const DisplaySlideCollection = collection<DisplaySlideType>('displaySlides')

export const DisplaySlideDetails = collection<SlideDetailsType>('displaySlideDetails')

export const UserTypeCollection = collection<UserType>('users')
